import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MEASUREMENT_UNITS } from '../../utils/constants';

function MeasurementUnitSelect(props) {
    const { value, onChange, ...rest } = props;
    return (
        <Select value={value} onChange={onChange} {...rest}>
            {MEASUREMENT_UNITS.map((unit) => (
                <MenuItem key={unit.value} value={unit.value}>{unit.label}</MenuItem>
            ))}
        </Select>
    );
}

export default MeasurementUnitSelect;
